<template>
  <div
    v-if="totalPages > 1"
    class="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-gray-50 rounded-b-lg"
  >
    <div class="flex flex-col sm:flex-row items-center justify-between gap-3">
      <p class="text-sm text-gray-700 text-center sm:text-left">
        {{
          $t('translation.pagination.showing', {
            from: (currentPage - 1) * itemsPerPage + 1,
            to: Math.min(currentPage * itemsPerPage, total),
            total,
          })
        }}
      </p>
      <div class="flex items-center gap-2">
        <button
          @click="$emit('previous')"
          :disabled="currentPage === 1"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronLeftIcon class="h-4 w-4" />
          <span class="hidden sm:inline">{{ $t('translation.pagination.previous') }}</span>
        </button>
        <span class="px-3 py-1.5 text-sm text-gray-700 font-medium">
          {{ $t('translation.pagination.page', { current: currentPage, total: totalPages }) }}
        </span>
        <button
          @click="$emit('next')"
          :disabled="currentPage === totalPages"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <span class="hidden sm:inline">{{ $t('translation.pagination.next') }}</span>
          <ChevronRightIcon class="h-4 w-4" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-vue-next'

interface Props {
  totalPages: number
  currentPage: number
  itemsPerPage: number
  total: number
}

defineProps<Props>()

defineEmits<{
  previous: []
  next: []
}>()
</script>
